import { MUNICIPALITIES_FAIL, MUNICIPALITIES_SHOW, MUNICIPALITIES_FETCH, MUNICIPALITIES_EDIT, MUNICIPALITIES_REQUEST, MUNICIPALITIES_FILTERED } from "../store/config";

const municipalityInit = {
	isFetching: false,
	list: [],
	pages:{
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q:''
	},
	filtered: {
		isFetching: false,
		list: []
	},
	edit: {},
	permissions: [],
	error: null,
	timestamp: null
};

const municipalities = (state = municipalityInit, action) => {
	switch(action.type) {
		case MUNICIPALITIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			};
		case MUNICIPALITIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			};
		case MUNICIPALITIES_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			};
		case MUNICIPALITIES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			};
		case MUNICIPALITIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case MUNICIPALITIES_FILTERED:
			return {
				...state,
				filtered: {
					...state.filtered,
					isFetching: action.isFetching,
					list: action.payload
				},
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
};

export default municipalities;


// WEBPACK FOOTER //
// ./src/reducers/municipalities.js